/** @jsx jsx */
import type { MouseEventHandler } from 'react';
import { jsx } from '@emotion/react';
import { useTab } from '@atlaskit/tabs';
import { Link } from '@reach/router';

import titleify from '../../utils/titleify';
import { token } from '@atlaskit/tokens';

interface TabProps {
  name: string;
  to: string;
  onClick?: VoidFunction;
}

const tabStyles = {
  textDecoration: 'none',
  padding: `${token('space.050', '4px')} ${token('space.150', '14px')}`,
  height: '2rem',
};

/** minimal */
const Tab = ({ name, to, onClick }: TabProps) => {
  const tabAttrs = useTab();

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (_) => {
    tabAttrs.onClick();
    onClick && onClick();
  };

  return (
    <Link
      {...tabAttrs}
      style={tabStyles}
      key={name}
      to={to}
      onClick={handleClick}
    >
      {titleify(name)}
    </Link>
  );
};

export default Tab;
